export default "__VITE_ASSET__VM2NcWtJ__";